import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth";
import { useAppContext } from "../config/AppContext.js";
import Icon1 from "../icons/Icon.js";
import { getDocDataById, getFlutterTime } from "../models/DataFunctions.js";
import MasterSmallStats, { BlockNumer } from "./home/MasterSmallStats.js";
import PrimaryButton from "../buttons/PrimaryButton";
import Modal1 from "../modals/Modal1.js";
import { formatToCentimes } from "../models/OrgFunctions.js";
import { useSearchParams } from "react-router-dom";
import { ParrainageModal } from "../modals/ParrainageModal.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import updateDocApi from "../api/database/updateDocApi.js";
import { useSnackbar } from "notistack";

function Recharge({
  userData,
  orgData,
  navigateWorkspace,
  workspaceData,
  overrideId,
}) {
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [searchParams] = useSearchParams();
  const [parrainageOpen, setParrainageOpen] = useState(
    searchParams.get("section") === "parrainage"
  );
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const [recharge_open, setRechargeOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [products, setProducts] = useState([
    {
      id: 1,
      title: "Lots de 10 crédits",
      promotion: "20€ offerts",
      units: 10,
      price: 580,
      black: false,
      reduction: 20,
    },
    {
      id: 2,
      title: "Lots de 40 crédits",
      promotion: "150€ offerts",
      units: 40,
      price: 2250,
      black: false,
      reduction: 150,
    },
    {
      id: 3,
      title: "Lots de 100 crédits",
      promotion: "500€ offerts",
      units: 100,
      price: 5500,
      black: true,
      reduction: 500,
    },
  ]);
  // Display loading message while checking authentication or fetching user data
  // If the data is still loading, show skeletons
  // loading || !currentUser || !userData
  const handleFetchData = async () => {};

  useEffect(() => {
    handleFetchData();
  }, []);

  const handleGenerateCode = async () => {
    setParrainageOpen(false);
    // lets create a random numeric code
    const code = Math.floor(Math.random() * 1000000);
    let codeString = "P-" + code.toString();
    await updateDocApi(
      "org",
      orgData.id,
      {
        "logement.parrainage": {
          code: codeString,
          activated: true,
          activation_date: new getFlutterTime(),
        },
      },
      prefix
    );
    handleClickVariant("Code de parrainage généré", "success");
  };

  const handleRecharge = async () => {
    let new_credits = orgData?.logement?.facturation?.credits || 0;
    new_credits += selectedProduct?.units;
    await updateDocApi(
      "org",
      orgData.id,
      {
        "logement.facturation.credits": new_credits,
        "logement.facturation.credits_bought":
          orgData?.logement?.facturation?.credits_bought +
          selectedProduct?.units,
      },
      prefix
    );
    handleClickVariant("Crédits rechargés", "success");
    setRechargeOpen(false);
  };

  // Function to fetch user and organization data
  const [hovering, setHovering] = useState(false);
  const handleBackdropClick = (e) => {
    if (e.target.className === e.currentTarget.className) {
      setParrainageOpen(false); // Close the modal if clicked on the backdrop
    }
  };
  if (!orgData) {
    return <></>;
  }

  return (
    <div className="flex flex-col h-full overflow-y-auto pl-4 max-w-c1p4k ">
      <div className="flex flex-col h-fit pb-20">
        {parrainageOpen &&
          orgData?.logement?.parrainage?.activated !== true && (
            <div
              onClick={(e) => {
                handleBackdropClick(e);
                e.stopPropagation();
              }}
              className="w-screen h-screen z-50 bg-shadow_25   flex flex-col  p-20  absolute top-0 left-0"
            >
              <ParrainageModal
                userData={userData}
                orgData={orgData}
                handleGenerateCode={handleGenerateCode}
              ></ParrainageModal>
            </div>
          )}
        <Modal1 isOpen={recharge_open} onClose={() => setRechargeOpen(false)}>
          <div className="flex flex-col  h-fit  text-shadow_50  w-c300 bg-white rounded-xl shadow-xl overflow-auto ">
            <div className="flex flex-col gap-2 items-start p-3 bg-black text-white rounded-t-xl">
              <div className="font-medium text-h1 ">Recharge</div>
            </div>
            <div className="flex flex-col gap-2 p-4">
              <div
                className={`text-black  rounded-xl  w-full  flex flex-col   `}
              >
                <div className=" text-h3 font-semibold flex flex-row  mb-2 ">
                  {selectedProduct?.title}
                </div>
                <div className="flex flex-row justify-between">
                  <div className=" text-h3 flex flex-row   ">Unités</div>
                  <div className=" text-h3 flex flex-row   ">
                    {selectedProduct?.units}
                  </div>
                </div>{" "}
                <div className="flex flex-row justify-between">
                  <div className=" text-h3 flex flex-row   ">Tarif HT</div>
                  <div className=" text-h3 flex flex-row   ">60,00 €</div>
                </div>{" "}
                <div className="flex flex-row justify-between">
                  <div className=" text-h3 flex flex-row   ">Réduction</div>
                  <div className=" text-h3 flex flex-row   ">
                    {" "}
                    - {formatToCentimes(selectedProduct?.reduction)}
                  </div>
                </div>{" "}
                <div className="flex flex-row justify-between">
                  <div className=" text-h3 flex flex-row   ">Total HT</div>
                  <div className=" text-h3 flex flex-row   ">
                    {formatToCentimes(
                      selectedProduct?.units * 60 - selectedProduct?.reduction
                    )}
                  </div>
                </div>
                <div className="flex flex-row justify-between">
                  <div className=" text-h3 flex flex-row   ">TVA</div>
                  <div className=" text-h3 flex flex-row   ">
                    {formatToCentimes(
                      (selectedProduct?.units * 60 -
                        selectedProduct?.reduction) *
                        0.2
                    )}
                  </div>
                </div>{" "}
                <div className="flex flex-row justify-between mt-2 font-semibold">
                  <div className=" text-h3 flex flex-row   ">Total TTC</div>
                  <div className=" text-h3 flex flex-row   ">
                    {formatToCentimes(
                      (selectedProduct?.units * 60 -
                        selectedProduct?.reduction) *
                        1.2
                    )}
                  </div>
                </div>
              </div>{" "}
              <div className="flex flex-row gap-2 justify-end mt-6">
                <PrimaryButton onClick={handleRecharge}>
                  Paiement Bridge
                </PrimaryButton>
              </div>
            </div>
          </div>
        </Modal1>
        <div className="text-hx text-black font-medium  ">
          Recharger mes crédits
        </div>{" "}
        {!orgData?.logement?.parrainage?.activated && (
          <div
            onClick={() => {
              setParrainageOpen(true);
            }}
            className="flex relative cursor-pointer hover:outline-none hover:outline-2 hover:outline-indigo-300 flex-col gap-2 rounded-lg  h-fit w-c1k  mt-4"
          >
            <div className="absolute z-20 w-full h-full gap-1  flex flex-col items-start justify-center p-4 pl-32">
              <div className="text-white text-hx ">
                Parrainez un <span className="font-semibold">confrère</span>
              </div>{" "}
              <div className="text-wshadow_75 text-h1 text- ">
                600€ offerts pour chaque parrainage
              </div>
            </div>
            <div className=" w-full h-full ">
              <img
                src="https://i.ibb.co/kVbpJsV3/Banni-re-Google-Play-500-x-100-px-6.png"
                className="rounded-xl"
              ></img>
            </div>
          </div>
        )}
        <div className="flex flex-row gap-2">
          <div className="flex flex-col ">
            <div className="flex flex-col w-fit h-fit  ">
              <div className="flex flex-wrap gap-2 max-w-c1p2k mt-4">
                <BlockNumer
                  icon="card"
                  fill="black"
                  title="Crédits restants"
                  onClick={() => navigateWorkspace("/recharge")}
                  number={orgData?.logement?.facturation?.credits || 0}
                />{" "}
                <BlockNumer
                  icon="card"
                  fill="black"
                  title="Crédits achetés"
                  onClick={() => navigateWorkspace("/recharge")}
                  number={orgData?.logement?.facturation?.credits_bought || 0}
                />{" "}
                <BlockNumer
                  icon="card"
                  fill="black"
                  title="Crédits gagnés"
                  onClick={() => navigateWorkspace("/recharge")}
                  number={orgData?.logement?.facturation?.credits_earned || 0}
                />
              </div>
            </div>
            <div className="flex flex-col w-fit h-fit  ">
              <div className="flex flex-wrap gap-2 max-w-c1p2k mt-4">
                <BlockRecharge
                  icon="card"
                  fill="black"
                  title="Lots de 10 crédits"
                  promotion="20€ offerts"
                  onClick={() => {
                    setSelectedProduct(products[0]);
                    setRechargeOpen(true);
                  }}
                />
                <BlockRecharge
                  icon="card"
                  fill="black"
                  title="Lots de 40 crédits"
                  promotion="150€ offerts"
                  onClick={() => {
                    setSelectedProduct(products[1]);
                    setRechargeOpen(true);
                  }}
                />
                <BlockRecharge
                  icon="card"
                  fill="black"
                  title="Lots de 100 crédits"
                  black={true}
                  promotion="500€ offerts"
                  onClick={() => {
                    setSelectedProduct(products[2]);
                    setRechargeOpen(true);
                  }}
                />
              </div>
            </div>
          </div>
          {orgData?.logement?.parrainage?.activated && (
            <div className="flex flex-col ml-auto mr-20 bg-white shadow-md shadow-blue-100 rounded-lg p-6 w-c300 h-fit mt-4">
              <div className="font-semibold text-h1 text-black">
                Parrainage{" "}
              </div>{" "}
              <div className=" text-h3 text-shadow_50 mt-2">
                Partagez votre code de parrainage avec vos confrères et gagnez
                600€ de crédits
              </div>
              <div
                onMouseEnter={() => setHovering(true)}
                onMouseLeave={() => setHovering(false)}
                onClick={() => {
                  navigator.clipboard.writeText(
                    "https://logement.hexagone.expert/signin?code=" +
                      orgData?.logement?.parrainage?.code
                  );
                  handleClickVariant(
                    "Code copié dans le presse-papier",
                    "success"
                  );
                }}
                className="my-4 bg-slate-100 rounded-full transition-all duration-300 gap-2 w-full   cursor-pointer hover:bg-primary  px-3 py-2 flex-row flex justify-between items-center"
              >
                {hovering ? (
                  <>
                    <div className="text-h3 text-white ">
                      cliquez pour copier
                    </div>
                    <Icon1 icon_name="copy" size={18} fill={"white"}></Icon1>
                  </>
                ) : (
                  <div className="flex flex-row gap-2 w-full max-w-full">
                    <div className="text-h3 text-shadow_50 text-nowrap text-ellipsis w-48 overflow-clip">
                      https://logement.hexagone.expert/signin?code=
                    </div>

                    <Icon1 icon_name="copy" size={18} fill={"#464dff"}></Icon1>
                  </div>
                )}
              </div>
              {orgData?.logement?.parrainage?.members?.map((member, index) => {
                return (
                  <div key={index}>
                    <FilleulBlock
                      name={member.name}
                      progress={member.progress}
                      subtitle={member.subtitle}
                    ></FilleulBlock>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Recharge;

export const BlockRecharge = ({
  title,
  promotion,
  icon = "folder",
  fill = "black",
  black = false,
  textclassname = "",
  onClick = () => {},
}) => {
  return (
    <div
      className={`${
        black
          ? "bg-white border-1 bg-gradient-to-br from-indigo-200 to-transparent "
          : "bg-white  text-black bg-gradient-to-r from-indigo-50 to-transparent"
      } rounded-xl cursor-pointer    p-4 flex flex-col border-1   w-c200   border-indigo-100`}
    >
      <div className=" text-h3 flex flex-row   ">{title}</div>
      <div
        className={` text-hx2 font-semibold  flex flex-row mb-2   ${textclassname}`}
      >
        {promotion}
      </div>
      <PrimaryButton onClick={onClick}>
        Recharger
        <Icon1 icon_name="plus" size={16} fill={"white"}></Icon1>
      </PrimaryButton>
    </div>
  );
};

export const FilleulBlock = ({ name, progress, subtitle }) => {
  return (
    <div className="flex flex-row gap-2 mt-2 items-center">
      <div className={`text-h3 text-shadow_50 font-normal`}>{name}</div>
      <div className=" relative h-2 gap-1 rounded-full items-center ml-auto w-32 flex flex-row  ">
        <div className="bg-neutral-100 rounded-full h-1.5 w-full">
          <div
            className="bg-green-400 rounded-full h-1.5 "
            style={{ width: progress < 0.5 ? "0%" : "100%" }}
          ></div>
        </div>
        <div className="w-6 ">
          <Icon1
            icon_name="done2"
            fill={progress < 0.5 ? "lightgrey" : "#4ade80"}
            size={16}
          ></Icon1>
        </div>
        <div className="bg-neutral-100 rounded-full h-1.5 w-full">
          <div
            className="bg-green-400 rounded-full h-1.5 "
            style={{ width: progress < 1 ? "0%" : "100%" }}
          ></div>
        </div>
        <div className="w-6 ">
          <Icon1
            icon_name="done2"
            fill={progress < 1 ? "lightgrey" : "#4ade80"}
            size={16}
          ></Icon1>
        </div>
      </div>
    </div>
  );
};
